import * as actions from "../action.constants";

const requestOrganization = () => ({
  type: actions.GET_ORGANIZATION,
});

const requestOrganizationImages = () => ({
  type: actions.GET_ORGANIZATION_IMAGES,
});

const storeOrganizationImages = (data) => {
  return {
    type: actions.STORE_ORGANIZATION_IMAGES,
    payload: data,
  };
};

const saveOrganizationImages = (data) => ({
  type: actions.SAVE_ORGANIZATION_IMAGES,
  payload: data,
});

export {
  requestOrganization,
  requestOrganizationImages,
  storeOrganizationImages,
  saveOrganizationImages,
};
